import { useEffect, useState } from 'react'
import type { NavData } from '@assessments/shared'
import { apiFetch } from '../services/apiClient.js'
import { getAppConfig } from '../config/appConfig.js'

interface NavigationState {
  nav: NavData | null
  loading: boolean
  error: string | null
}

export function useNavigation(): NavigationState {
  const navUrl = getAppConfig().platformNavigationApiUrl

  const [state, setState] = useState<NavigationState>({
    nav: null,
    loading: Boolean(navUrl),
    error: null,
  })

  useEffect(() => {
    if (!navUrl) {
      setState({
        nav: null,
        loading: false,
        error: 'Platform navigation URL is not configured',
      })
      return
    }

    apiFetch(navUrl)
      .then(async (res) => {
        if (!res.ok) throw new Error(`Navigation fetch failed: ${res.status}`)
        const data = (await res.json()) as NavData
        setState({ nav: data, loading: false, error: null })
      })
      .catch((err: unknown) => {
        setState({ nav: null, loading: false, error: String(err) })
      })
  }, [navUrl])

  return state
}
